<template>
  <div class="form-group as-form-richtexteditor">
    <main class="as-form-richtexteditor__main">
      <div class="as-form-richtexteditor__placeholder" ref="editorPlaceholder"></div>
    </main>
  </div>
</template>
